import { render, staticRenderFns } from "./PowerByCf247Text.vue?vue&type=template&id=fe4aee56&scoped=true"
import script from "./PowerByCf247Text.vue?vue&type=script&lang=js"
export * from "./PowerByCf247Text.vue?vue&type=script&lang=js"
import style0 from "./PowerByCf247Text.vue?vue&type=style&index=0&id=fe4aee56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4aee56",
  null
  
)

export default component.exports